import React from 'react'
import R from 'ramda'
import { createCellEditor } from 'table-utils'
import { Select } from 'antd'
import { fromNullable } from 'data.maybe'

const createDropDownEditor = options => ({
  editContent,
  style,
  onBlur,
  onEdit,
  // parent,
  commitEdit,
  editInitKey,
  refBinder,
  width,
  upward,
  scrolling,
  selection,
}) => {
  const finalStyle = {
    ...style,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
  if (width) {
    finalStyle.maxWidth = width
    finalStyle.width = width
    finalStyle.flex = `0 0 ${width}`
  }
  const selected = editInitKey
    ? fromNullable(
        R.find(
          ({ value, text }) =>
            value.toLowerCase().startsWith(editInitKey.toLowerCase()) ||
            text.toLowerCase().startsWith(editInitKey.toLowerCase()),
          options
        )
      )
        .map(v => v.value)
        .getOrElse(editContent)
    : editContent

  return (
    <Select
      options={options}
      ref={refBinder}
      onBlur={onBlur}
      style={finalStyle}
      type="text"
      value={selected}
      onChange={value => {
        onEdit(value)
        commitEdit(value)
      }}
      defaultOpen
      upward={upward}
      scrolling={scrolling}
      selection={selection}
    >
      {options.map(e => (
        <Select.Option key={e} value={e.value}>
          {e.text}
        </Select.Option>
      ))}
    </Select>
  )
}

export default options => createCellEditor(createDropDownEditor(options))
